import { CommercialPermitTransactionModel } from './commercial-permit-transaction.model';
import { CommercialVehicleMiscRequirementModel } from './commercial-vehicle-misc-requirement.model';

export class CopyCommercialPermitModel extends CommercialPermitTransactionModel {
    public previousCommercialVehiclePermitNumberId: number;
    public vehicleIds: number[];
    public requirements: any[];
    public additionalRequirements: CommercialVehicleMiscRequirementModel;
}
